// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"554":"a5a0a3cf","771":"2b829fb8"}[chunkId] + ".chunk.css";
};